import { useLocaleState, useRecordContext } from "react-admin";

import LabelAttachedField from "../../unit/LabelAttachedField";
import LabelField from "../../unit/LabelField";
import { Grid } from "@mui/material";

const Funding = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} md={6} lg={6}>
          <LabelField
            title="Date Funded"
            value={record.created_at}
            format="date"
            prefix="EST"
          />
          <LabelField title="Funded By" value={record.sOper} />
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {record.sComment && record.sComment.length > 0 ? (
            <LabelField
              title="Comment"
              value={record.sComment}
              format="richtext"
              titlePosition="top"
            />
          ) : (
            <></>
          )}
          {record.filelist && record.filelist.length > 0 ? (
            <LabelAttachedField list={record.filelist} titlePosition="top" />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Funding;
